import React, {useEffect, useMemo} from "react";
import {TabsSection} from "./widgets/Styled";
import TopSection from "./widgets/TopSection";
import PersonalDetails from "./widgets/PersonalDetails";
import FutureEducation from "./widgets/FutureEducation";
import CurrentEducationWrapper from "./widgets/CurrentEducationWrapper";
import {Form} from "react-final-form";
import {
    SignUpFormData,
    SignUpActions,
    FieldData,
    FormType,
} from "../../containers/RegistrationLoginPage/types";
import {useSelector} from "react-redux";
import {RootStore} from "../../configureStore";
import DisclaimerField from "./widgets/Fields/DisclaimerField";
import focusOnFirstFieldDecorator from "./decorators/focusOnFirstFieldDecorator";
import setFieldTouched from "./mutators/setFieldTouched";
import {useLocation} from "react-router";
import SignUpButton from "./widgets/Fields/SignUpButton";
import {useDispatch} from "react-redux";
import {ThunkDispatch} from "redux-thunk";
import useCreateLeadAndResponse from "../../hooks/useCreateLeadAndResponse";
import {getPageType, onSubmit} from "../../containers/RegistrationLoginPage/utils";
import LossAversionLayerWrapper from "./widgets/LossAversionLayer/index";
import {FormUl, FormUlList, TabsContent} from "./widgets/loaderStyled";
import FormLevelError from "../Login/widgets/FormLevelError";
import SignUpFormOnSubmitContentLoader from "./widgets/SignUpFormOnSubmitContentLoader";
import {useEventTracking} from "../../hooks/useEventTracking";
import {DownloadBrochureTrackingData} from "../CTA/types";
import {
    getCTATrackingEventCategory,
    getCTATrackingWidget,
    getListingType,
    getListingTypeId,
    getListingTypeIdTracking,
    getListingTypeTracking,
    isListingType,
    isListingTypeForTracking,
} from "../CTA/response";

interface RegistrationComp {
    signUpPageData: SignUpFormData;
    cropSize: {width: number; height: number};
}
const Registration: React.FC<RegistrationComp> = ({signUpPageData, cropSize}: RegistrationComp) => {
    const fields = signUpPageData.fields as FieldData;
    const formType = signUpPageData.formType as FormType;
    const headingData = signUpPageData.headingData;
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);
    const showPersonalSection = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.showPersonalSection,
    );

    const focusOnErrors = useMemo(() => focusOnFirstFieldDecorator(), []);
    const location = useLocation();

    const trackingId = useSelector((state: RootStore) => state.RegistrationLoginPage.trackingKey);
    const ctaTrackingData = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.ctaTrackingData,
    );
    const currentClass = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.bachelorFields?.currentClass,
    );
    const dispatch = useDispatch<ThunkDispatch<RootStore, void, SignUpActions>>();
    const createLeadAndResponse = useCreateLeadAndResponse();

    const currentPageName = useSelector((state: RootStore) => state.layout.currentPageName);

    const userType = useSelector(
        (state: RootStore) => state.layout.userAndShortlistData?.userBasicDetail?.type,
    );

    const triggerEvent = useEventTracking(
        getCTATrackingEventCategory(ctaTrackingData) === ""
            ? "signup"
            : getCTATrackingEventCategory(ctaTrackingData),
    );

    // console.log("ctaTrackingData on reg page", ctaTrackingData);

    useEffect(() => {
        //const eventName = getCTATrackingEventCategory(ctaTrackingData);
        console.log("hereee in effect");
        let listingTypePresent = false;
        if (ctaTrackingData) {
            console.log("inside if");
            listingTypePresent = isListingTypeForTracking(ctaTrackingData);
        }
        console.log("listingTypePresent", listingTypePresent);

        if (listingTypePresent) {
            let trackingAdditionalData = [];
            const listingTypeId = getListingTypeIdTracking(ctaTrackingData);
            const listingType = getListingTypeTracking(ctaTrackingData);
            const widget = getCTATrackingWidget(ctaTrackingData);
            trackingAdditionalData = [
                {
                    entityName: listingType,
                    entityValue: [listingTypeId.toString()],
                },
                {
                    entityName: "userType",
                    entityValue: [userType ?? "logged_out"],
                },
            ];
            console.log("trackingAdditionalData", trackingAdditionalData);
            void triggerEvent({
                theme: "ctaAction",
                category: "ctaClick",
                widget: widget,
                label: ctaTrackingData?.ctaType ?? "",
                eventName: "click",
                trackingAdditionalData: trackingAdditionalData,
            });
        }
    }, [userType, ctaTrackingData, triggerEvent]);

    // console.log("ctaTrackingData on reg page", ctaTrackingData);
    // console.log("currentPageName reg page", currentPageName);

    return useMemo(() => {
        const {pathname} = location;
        const {pageStatus} = getPageType(pathname);
        const {isUserEditProfile} = pageStatus;
        return (
            <TabsContent>
                {!isUserEditProfile && <LossAversionLayerWrapper />}
                <Form
                    onSubmit={onSubmit({
                        trackingId,
                        currentClass,
                        ctaTrackingData,
                        signUpPageData,
                        isMobile,
                        location,
                        dispatch,
                        createLeadAndResponse,
                    })}
                    decorators={[focusOnErrors]}
                    mutators={{setFieldTouched}}
                    subscription={{
                        submitting: true,
                        pristine: true,
                    }}
                >
                    {(object) => {
                        const {handleSubmit, values, submitting} = object;
                        return (
                            <form onSubmit={handleSubmit} autoComplete="off" noValidate={true}>
                                {headingData && <TopSection headingData={headingData} />}
                                {showPersonalSection && (
                                    <PersonalDetails
                                        values={values}
                                        fields={fields}
                                        formType={formType}
                                        cropSize={cropSize}
                                    />
                                )}

                                <FutureEducation
                                    course={fields.course}
                                    intakeYear={fields.intakeYear}
                                    preferredCountry={fields.preferredCountry}
                                    preferredLevel={fields.preferredLevel}
                                    formType={formType}
                                    showPersonalSection={showPersonalSection}
                                />
                                <CurrentEducationWrapper
                                    fields={fields}
                                    showPersonalSection={showPersonalSection}
                                />

                                <TabsSection>
                                    <FormUl>
                                        <FormUlList fullWidthDiv>
                                            <DisclaimerField />
                                        </FormUlList>
                                        <FormUlList fullWidthDiv>
                                            <SignUpButton
                                                heading={signUpPageData.headingData?.buttonText}
                                            />
                                        </FormUlList>
                                        <FormLevelError />
                                    </FormUl>
                                </TabsSection>
                                {submitting && <SignUpFormOnSubmitContentLoader />}
                                {/* <pre>
                                                {
                                                    //JSON.stringify(values, undefined, 2)
                                                    <FormSpy
                                                        subscription={{
                                                            values: true,
                                                        }}
                                                    >
                                                        {({values}) => (
                                                            <pre>
                                                                {JSON.stringify(
                                                                    values,
                                                                    undefined,
                                                                    2,
                                                                )}
                                                            </pre>
                                                        )}
                                                    </FormSpy>
                                                }
                                            </pre> */}
                            </form>
                        );
                    }}
                </Form>
            </TabsContent>
        );
    }, [
        createLeadAndResponse,
        ctaTrackingData,
        currentClass,
        dispatch,
        fields,
        focusOnErrors,
        formType,
        headingData,
        isMobile,
        location,
        showPersonalSection,
        signUpPageData,
        trackingId,
        cropSize,
    ]);
};
export default Registration;
